import * as z from "zod";

import { REQUIRED_MESSAGE, requiredString } from "components/form/utils";

export const referenceObject = () =>
  z
    .object({
      id: requiredString(),
    })
    .or(z.literal(undefined))
    .or(z.literal(null))
    .refine((val) => !!val && !!val.id?.trim(), {
      message: REQUIRED_MESSAGE,
    });

export const projectSchema = z.object({
  name: requiredString().nonempty("Project cannot be empty"),
  logo: z.optional(z.string()).nullable(),
  project_id: requiredString(),
  client: referenceObject(),
  account_manager: referenceObject(),
  sales_coordinator: referenceObject(),
  coordinator: referenceObject(),
  legal_entity: requiredString(),
  // description: z.string(),
  status: requiredString(),
  tags: z.optional(z.any()).nullable(),
});
